import ProductsListBgColorNoneP0 from "./ProductsListBgColorNoneP0"

export default function ProductsRecommendation() {
    return (
        <div className="products-recommendation">
            <div className="styles_containerPage__eKW1A MuiBox-root css-0 !mt-[20px]">
                <div className="styles_wrapper_media__8E69V">
                    <div className="styles_wrapper_media_container__mzr38">
                        <div className="styles_SliderProductWrap__FM9kz" style={{ backgroundSize: "100% 100%" }}>
                            <div
                                className="styles_wrapperTitle__DaSRf"
                                style={{ visibility: "visible" }}
                            >
                                <h2 className="styles_title__W7HFl styles_wrapperContentTitle__AGJR6">
                                    <span className="styles_contentTitle__y8kvU">Sản phẩm gợi ý</span>
                                </h2>

                                <div className="styles_seeAllWrapper__LVbbZ MuiBox-root css-0">
                                    <a
                                        className="styles_mobile_rootBase__8z7PQ styles_seeAll__R2mnW"
                                        href="/products"
                                    >
                                        Xem tất cả
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M16.006 11.0818C16.5418 11.5767 16.5418 12.4233 16.006 12.9182L11.5982 16.99C10.7976 17.7295 9.5 17.1617 9.5 16.0718V7.9282C9.5 6.83829 10.7976 6.27045 11.5982 7.01001L16.006 11.0818Z"
                                                fill="#005C29"
                                            ></path>
                                            <rect
                                                x="0.5"
                                                y="0.5"
                                                width="23"
                                                height="23"
                                                rx="11.5"
                                                stroke="#005C29"
                                            ></rect>
                                        </svg>
                                    </a>
                                </div>
                            </div>

                            <div className="false css-j7qwjs">
                                <ProductsListBgColorNoneP0 />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
